import { Component } from '@angular/core';
import { CatalogService } from '../../services/catalog.service';
import { WindowService } from '../../services/window.service';
import { slideToLeftTransition} from '../../animations'

@Component({
  template: `
    <section [@slideToLeftTransition]="getState(ordersheetsOutlet)">
    <router-outlet #ordersheetsOutlet="outlet">
    </router-outlet>
    </section>
    `,
    animations: [slideToLeftTransition]
})

export class OrderSheetsComponent {
  
  constructor(
    private catalogService: CatalogService,
    private windowService: WindowService) { }


  // change the animation state
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }
}
